var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map",staticStyle:{"flex":"1"}},[_c('div',{ref:"mapBox",staticStyle:{"width":"3.75rem","min-height":"300px","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }